<div style="position: relative;" [ngClass]="{'autoevaluacionCheck': autoevaluacionCheck && mostrarAutoevaluacion}">
  <img class="autoevaluacion-check__img" *ngIf="autoevaluacionCheck && mostrarAutoevaluacion" [src]="urlImagen">
  <button class="estiloInicial retroalimentacion-trabajo-alumno" 
    *ngIf="{checked: checked$ | async} as data" 
    [matTooltip]="criterioNombre + ' (' + criterioId + ')'"
    matTooltipClass="criterio-tooltip"
    [ngClass]="{
      'estiloOtro': data.checked,
      'estiloLd': label === 'LD' && data.checked,
      'estiloL': label === 'L' && data.checked,
      'estiloLp': label === 'LP' && data.checked,
      'estiloNl': label === 'NL' && data.checked,
      'estiloP': label === 'P' && data.checked
    }"
    (click)="onClick()">{{label}}
  </button>
<div>
